export default __webpack_public_path__ + "static/media/sahinoglu7.4c7fbcc5.jpg";